module.exports = __webpack_public_path__ + "img/ab4eb8fc1e30c7f9086c402a25423b2d.png";